const sortCaseInsensitive = (prev, curr, key) => {
  if (prev[key]?.toLowerCase() > curr[key]?.toLowerCase()) {
    return 1;
  } if (prev[key]?.toLowerCase() < curr[key]?.toLowerCase()) {
    return -1;
  }
  return 0;
};

export default sortCaseInsensitive;
